import stateChangesMap from '../redux/_stateChangesMap';

import mergeObject, { MergeObjectOptions } from './_mergeObject';

/**
 * @visibleName merge
 * @since 0.19.2
 * @component
 */
export default function mergeState(object: object, source: {[index: string]: unknown}, options: MergeObjectOptions = {}) {
  const changes: string[] = [];

  const merged = mergeObject(object, source, { changes, ...options });

  stateChangesMap.set(merged, changes);

  return merged;
}
